import { render, staticRenderFns } from "./availability-bar.vue?vue&type=template&id=64889966&"
import script from "./availability-bar.vue?vue&type=script&lang=js&"
export * from "./availability-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports